export const NOTIFICATION_DURATION = 5000
export const ANIMATION_DROPDOWN_DURATION = 260
export const DELAY_HIDE_MODAL_DURATION = 260
export const WAIT_CREATIVES_REQUEST_TIME = 10000
export const REQUEST_INTERVAL = 10000
export const COOKIE_MAX_AGE = 60 * 60 * 24 * 365
export const WAIT_STATISTS_LOAD_TIME = 3000
